module.exports = __webpack_public_path__ + "img/4.daea11c9.png";